import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../_components/Navigation';

import { userService } from '../_services';

class RecoverPage extends React.Component {
    goBack = () => { this.props.router.navigate(-1); }
    
    handleChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }
    
    recoverPassword = (event) => {
        event.preventDefault();
        this.setState({
            status: "sending",
            error: ""
        });
        if(!this.state.email) {
            this.setState({
                status: "",
                error: "Email cannot be blank"
            });
            return;
        }
        userService.recoverPassword(this.state.email)
        .then(() => {
            this.setState({
                sentEmail: this.state.email,
                status: "sent"
            });
        });
    }

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.state = {
            status: "",
            email: "",
            sentEmail: "",
            error: ""
        };
    }

    render() {
        return (
        <div>
            <Navigation active="" />
            <div className="jumbotron">
                <div className="container-fluid padding-lr55">
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="row">
                                <div className="col-xs-12">
                                    <h3>Recover password</h3>
                                    <p>Please enter your email address and click recover. Your password will then be emailed to your email address.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-8 col-md-6 col-lg-4">
                            <form className="flat" id="form-recover">
                                <div className="form-group">
                                    <label htmlFor="email">*Email</label>
                                    <input className="form-control" type="text" id="email" name="email" value={this.state.email} onChange={this.handleChange}/>
                                    {this.state.error &&
                                        <div className="text-danger">{this.state.error}</div>
                                    }
                                </div>
                                <div className="form-group">
                                    <button type="button" className="btn btn-dl-green pull-left margin-r10" onClick={this.recoverPassword}>RECOVER</button>
                                    {this.state.status == "sending" &&
                                        <span className="glyphicon glyphicon-refresh glyphicon-spin padding-lr10" />
                                    }
                                    <button type="button" className="btn btn-dl-green pull-left" onClick={this.goBack}>CANCEL</button>
                                </div>
                                {this.state.status == "sent" &&
                                <div style={{clear:"both"}} className="padding-t40">
                                    If the email address you entered is registered with Deadline Express, you'll receive an email with your password.
                                    <br/>
                                    Please check your email inbox and spam folder for this email.
                                    <br/><br/>
                                    If you do not receive it, please contact us to recover your password.
                                    <br/><br/>
                                    <Link to="/login">Click here to login</Link>
                                </div>
                                }
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        );
    }
}

export { RecoverPage };